import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const customEase = [0.16, 1, 0.3, 1];
  const faqs = [{
    question: 'Do I need any prior makeup experience?',
    answer: 'Not at all. Our masterclasses are designed to be accessible for complete beginners while still offering advanced techniques for those with more experience. We tailor our guidance to your individual skill level.'
  }, {
    question: 'What products do I need to bring?',
    answer: 'We provide all necessary products and tools for the masterclass. However, we encourage you to bring your own makeup bag so we can show you how to get the most out of the products you already own.'
  }, {
    question: 'How do I book a class?',
    answer: "Browse our upcoming masterclasses, select your preferred date and city, and complete the booking process online. You'll receive instant confirmation with all class details, venue information, and what to expect on the day. Secure your spot with a simple online payment — we accept all major cards."
  }, {
    question: 'Do you offer private group sessions?',
    answer: 'Yes, we offer private masterclasses for groups of 4 or more. These are perfect for bridal parties, corporate wellness days, or a special day out with friends. Please contact us for a custom quote.'
  }];
  return <section id="faqs" className="py-24 md:py-32 lg:py-40 bg-cream texture-grain" data-id="element-86">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-87">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24" data-id="element-88">
          {/* Left Column - Sticky Heading */}
          <div className="w-full lg:w-[40%]" data-id="element-89">
            <div className="lg:sticky lg:top-32" data-id="element-90">
              <motion.h2 initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              ease: customEase
            }} className="font-serif text-5xl md:text-6xl font-light text-ink leading-tight" data-id="element-91">
                Frequently Asked
                <br data-id="element-92" />
                Questions
              </motion.h2>
            </div>
          </div>

          {/* Right Column - Accordion */}
          <div className="w-full lg:w-[60%]" data-id="element-93">
            <div className="border-t border-cream-dark" data-id="element-94">
              {faqs.map((faq, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: index * 0.05,
              ease: customEase
            }} className="border-b border-cream-dark" data-id="element-95">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-8 flex items-center justify-between text-left group" data-id="element-96">
                    <span className="font-serif text-2xl md:text-3xl font-medium text-ink group-hover:text-copper transition-colors pr-8" data-id="element-97">
                      {faq.question}
                    </span>
                    <span className="relative w-6 h-6 flex-shrink-0 flex items-center justify-center" data-id="element-98">
                      <span className="absolute w-full h-[1px] bg-copper" data-id="element-99" />
                      <span className={`absolute w-[1px] h-full bg-copper transition-transform duration-500 ease-out ${openIndex === index ? 'rotate-90 scale-0' : 'rotate-0 scale-100'}`} data-id="element-100" />
                    </span>
                  </button>

                  <AnimatePresence data-id="element-101">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  type: 'spring',
                  stiffness: 100,
                  damping: 20
                }} className="overflow-hidden" data-id="element-102">
                        <div className="pb-8 pr-12" data-id="element-103">
                          <p className="font-sans text-stone text-lg leading-relaxed" data-id="element-104">
                            {faq.answer}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}